import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { Subscription, filter, fromEvent, switchMap } from 'rxjs';

@Directive({
  selector: '[webDesignSystemCopyToClipboard]',
  standalone: true,
})
export class CopyToClipboardDirective implements OnInit, OnDestroy {
  @Input() public copyText = '';

  @Output() public copied = new EventEmitter<string>();
  @Output() public copyFailed = new EventEmitter<void>();

  #eventSub = new Subscription();

  readonly #host = inject(ElementRef<HTMLElement>);

  ngOnInit() {
    this.#eventSub.add(
      fromEvent(this.#host.nativeElement, 'click')
        .pipe(
          filter(() => !!this.copyText),
          switchMap(() => navigator.clipboard.writeText(this.copyText)),
        )
        .subscribe({
          next: () => this.copied.emit(this.copyText),
          error: () => this.copyFailed.emit(),
        }),
    );
  }

  ngOnDestroy(): void {
    this.#eventSub.unsubscribe();
  }
}
